import { createSlice } from "@reduxjs/toolkit";
import editTeleServicePrice from "../../../rtk-apis/Setting/editTeleServicePrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const editTeleServicePriceSlice = createSlice({
    name: "editTeleServicePriceSlice",
    initialState,
    reducers: {
        clearEditTeleServicePriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editTeleServicePrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(editTeleServicePrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(editTeleServicePrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.error = payload as any;
            });
    },
});

export default editTeleServicePriceSlice.reducer;
export const { clearEditTeleServicePriceState } = editTeleServicePriceSlice.actions;
